'use strict';
var React = require('react');
var AutoSizeHelper = require('../common/AutoSizeHelper');
var styleHelper = require('../../helper/styleHelper');

/*
 * 链接组件
 */
var Link = React.createClass({

  componentWillReceiveProps: function (nextProps) {
    if (nextProps.text !== this.props.text) {
      this.isInvalid = true;
    }
  },

  componentDidUpdate: function () {
    if (this.isInvalid) {
      this.isInvalid = false;
      this._doPaint();
    }
  },

  _doPaint: function () {
    var com;
    var parentDom;
    var size;

    if (this.props.isAutoSize) {
      com = ReactDOM.findDOMNode(this);
      parentDom = com.parentElement;

      while (!parentDom && (parentDom.id !== this.props.controlID)) {
        parentDom = parentDom.parentElement;
      }

      if (parentDom) {
        size = AutoSizeHelper.getComAutoSize(this.props);
        parentDom.style.width = size.width + 4 + 'px';
        parentDom.style.height = size.height + 2 + 'px';
      }
    }
  },

  render : function(){
    var style = {
      width:'100%',
      height:'100%'
    };
    styleHelper.StyleUtil(this.props,style).text();
    return (
      <div style={style}>
        <label>{styleHelper.getText(this.props)}</label>
      </div>
    );
  }

});

module.exports = Link;



/** WEBPACK FOOTER **
 ** ./src/views/Components/Link.jsx
 **/